import { Box } from '@mui/material';

import React from 'react';

import { useLocation } from 'react-router-dom';

import Container from '@src/components/commons/containerPage.common';
import LabTabs from '@src/components/commons/tabs.common';

import DownloadFinancialReports from './download-reports.tab';
import SendReports from './sendReports';
import ViewSentReports from './viewSentReport';

function FinancialReportsPage() {
  const path = useLocation().pathname;

  const menus = [
    {
      idx: 0,
      title: 'Download',
      component: (
        <Box>
          <DownloadFinancialReports />
        </Box>
      ),
    },
    {
      idx: 1,
      title: 'Send Reports to Branch',
      component: (
        <Box>
          <SendReports />
        </Box>
      ),
    },
    {
      idx: 2,
      title: 'View Sent Reports',
      component: (
        <Box>
          <ViewSentReports />
        </Box>
      ),
    },
  ];

  return (
    <Container pathUrl={path}>
      <Box className='px-2 py-8'>
        <LabTabs menus={menus} label='financial-reports-tabs' />
      </Box>
    </Container>
  );
}

export default FinancialReportsPage;
